import { render, staticRenderFns } from "./BxKuncunForm.vue?vue&type=template&id=2b85f6a7&"
import script from "./BxKuncunForm.vue?vue&type=script&lang=js&"
export * from "./BxKuncunForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports